<template>
  <article>
    <span class="duplicata_parcelada">
      <v-tooltip top :close-delay="500" allow-overflow>
        <v-chip
          slot="activator"
          small
          color="grey darken-1"
          text-color="white"
          @click.native="openTabelaParcela(item)"
        >{{item.rela_arrayLogins.length}}</v-chip>
        <span>Visualizar tabela de Acessos</span>
      </v-tooltip>
    </span>
    <v-dialog @keydown.esc="openDialog = false" v-model="openDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span>
            <strong>{{item.rela_nome}}</strong>
          </span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="openDialog=false">
            <v-icon color="red">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <table border="1" class="table_vencimento">
                  <thead>
                    <tr>
                      <th colspan="3">Acessos</th>
                    </tr>
                    <tr>
                      <th colspan="1">Datas</th>
                      <th colspan="1">Horário</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,i) in sortArrayItemDesc" :key="i">
                      <td class="text-xs-center">{{item ? new Date(item).toLocaleDateString(): '-'}}</td>
                      <td class="text-xs-center">{{item ? new Date(item).toLocaleTimeString(): '-'}}</td>
                    </tr>
                  </tbody>
                </table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click.stop="openDialog=false">Fechar</v-btn>
          <!-- <v-btn color="success"  @click.stop="newColumn()">Criar</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </article>
</template>
<script>
export default {
  props: ["item", "empresa", "component"],
  beforeMount() {},
  data: () => ({
    openDialog: false
  }),
  computed: {
    sortArrayItemDesc: function(){
      return this.item.rela_arrayLogins && this.item.rela_arrayLogins.length > 0 ? this.item.rela_arrayLogins.sort((a,b)=> {return a < b ? 1 : a > b ? -1 : 0}) : [];
    }
  },
  methods: {
    openTabelaParcela: function() {
      this.openDialog = true;
    }
  }
};
</script>
<style>
.duplicata_sem_dt_venc {
  color: red;
}
.table_vencimento {
  border-collapse: collapse;
  width: 100%;
}
.table_vencimento td,
.table_vencimento th {
  border: 1px solid black;
}
.table_vencimento td {
  padding: 0px 5px;
}
.table_vencimento td.valorReais {
  position: relative;
}
.table_vencimento td.valorReais:before {
  content: "R$";
  left: 4px;
  position: absolute;
}
.duplicata_parcelada span.v-chip__content {
  cursor: pointer;
  font-size: 1.7em !important;
}
</style>
  



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_logins/Coluna_Logins.vue